import './app.css';
import { loadRuntimeConfig } from './config/auth-config';
import { authenticateWithCognito } from './auth/cognito-auth';
import App from './lib/components/App.svelte';
import { mount } from 'svelte';

async function bootstrap() {
  await loadRuntimeConfig();
  await authenticateWithCognito();

  mount(App, {
    target: document.getElementById('app')!,
  });
}

bootstrap();
